import { createApp } from 'vue'

const app = createApp({
    data() {
        return {
            query: {
                email: '',
                customerNumber: '',
                zip: ''
            },
            reply: {},
            noHits: false,
            customer: {},
            complete: false,
            error: null,
            errorMessage: ""
        };
    },
    methods: {
        search() {
            this.error = null;
            this.errorMessage = "";
            window.fetch(
                    '/konto/api/identify',
                    {
                        method: 'post',
                        body: JSON.stringify(this.query),
                        headers: {
                            'Content-Type': 'application/json'
                        }
                    }
                )
                .then(response => {
                    response.json().then(data => {
                        this.reply = data;
                        this.noHits = !data.customerAvailable && !data.isUnique && !data.isCommon;
                    });
                });
        },
        invite() {
            this.error = null;
            this.errorMessage = "";
            window.fetch(
                    '/konto/api/invitemember',
                    {
                        method: 'post',
                        body: JSON.stringify(this.query),
                        headers: {
                            'Content-Type': 'application/json'
                        }
                    }
                )
                .then(response => {
                    try {

                        if (response.ok) {
                            this.complete = true;
                        } else if (response.status === 400) {
                            this.errorMessage = "E-postadressen er allerede tilknyttet en bruker. Benytt glemt passord.";
                            this.error = new Error("Failed to invite");
                        } else {
                            response.text().then(d =>
                                this.error = new Error("Failed to invite\n" + d)
                            );
                        }

                    } catch (ex) {
                        this.error = ex;
                    }
                })
                .catch(error => {
                    this.error = error;
                });
        }
    },
    computed: {
        showExtended() {
            return (this.reply.customerAvailable && !this.reply.isUnique)
                || this.query.zip
                || this.query.customerNumber;
        },
        showSuccess() {
            return this.reply.customerAvailable
                && this.reply.isUnique;
        },
        showCommon() {
            return this.reply.isCommon;
        },
        showNoHits() {
            return this.noHits;
        },
        incomplete() { return !this.complete; }
    },
    watch: {
        query: {
            handler() {
                if (this.$refs.form.checkValidity()) {
                    this.search();
                }
            },
            deep: true
        },
        'query.email'() { this.$refs.email.classList.add('touched'); },
        'query.zip'() { this.$refs.zip.classList.add('touched'); },
        'query.customerNumber'() { this.$refs.customerNumber.classList.add('touched'); }
    }
});

app.mount('#newUserExistingCustomer');